export const ADDRESS_LOOK_UP = gql`
    mutation addressLookUp($address: String!) {
        addressLookUp(address: $address) {
            id
            text
        }
    }
`;
export const GET_ADDRESS_DETAILS = gql`
    mutation address($addressId: String!) {
        address(addressId: $addressId) {
            id
            buildingNumber
            street
            district
            city
            line1
            line2
            adminAreaName
            province
            provinceName
            postalCode
            countryName
        }
    }
`;
